import React from "react"
import { PolicyWorklistResults } from "../features/policyWorklist/PolicyWorklistResults"

function PolicyWorklist(){
    return <React.Fragment>
        <PolicyWorklistResults/>
    </React.Fragment>
}
export {PolicyWorklist}